<template>
    <CompassMenu
        placement="top-start"
        trigger="click"
        customClass="custom-menu-container"
        :disabled="disabled"
    >
        <CompassTooltip
            :content="getExtensionOptionLabel()"
            :delay="{ show: 0, hide: 1 }"
            :disabled="disabled"
            placement="top"
        >
            <SelectRichText
                :label="getExtensionOptionLabel()"
                :disabled="disabled"
                :active="activeStyle(option)"
            />
        </CompassTooltip>
        <template #dropdown>
            <CompassDropdownOption
                class="custom-menu-item"
                @itemSelected="getExtensionOption('Unformat').action()"
            >
                <span class="typographies-paragraph-small-regular">
                    {{ $t.__(getExtensionOption('Paragraph').label) }}
                </span>
                <span class="typographies-paragraph-small-regular option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Unformat').shortcuts) }}
                </span>
            </CompassDropdownOption>
            <CompassDropdownOption
                class="custom-menu-item"
                @itemSelected="getExtensionOption('Blockquote').action()"
            >
                <span class="typographies-paragraph-small-regular">
                    {{ $t.__(getExtensionOption('Blockquote').label) }}
                </span>
                <span class="typographies-paragraph-small-regular option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Blockquote').shortcuts) }}
                </span>
            </CompassDropdownOption>
            <CompassDropdownOption
                class="custom-menu-item"
                @itemSelected="getExtensionOption('Code').action()"
            >
                <span class="custom-menu-item__richtext-code">
                    <code>{{ $t.__(getExtensionOption('Code').label) }}</code>
                </span>
                <span class="typographies-paragraph-small-regular option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Code').shortcuts) }}
                </span>
            </CompassDropdownOption>
            <CompassDropdownOption
                class="custom-menu-item"
                @itemSelected="getExtensionOption('Heading1').action()"
            >
                <h1 class="typographies-heading-h1 heading">
                    {{ $t.__(getExtensionOption('Heading1').label) }}
                </h1>
                <span class="typographies-paragraph-small-regular option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading1').shortcuts) }}
                </span>
            </CompassDropdownOption>
            <CompassDropdownOption
                class="custom-menu-item"
                @itemSelected="getExtensionOption('Heading2').action()"
            >
                <h2 class="typographies-heading-h2 heading">
                    {{ $t.__(getExtensionOption('Heading2').label) }}
                </h2>
                <span class="typographies-paragraph-small-regular option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading2').shortcuts) }}
                </span>
            </CompassDropdownOption>
            <CompassDropdownOption
                class="custom-menu-item"
                @itemSelected="getExtensionOption('Heading3').action()"
            >
                <h3 class="typographies-heading-h3 heading">
                    {{ $t.__(getExtensionOption('Heading3').label) }}
                </h3>
                <span class="typographies-paragraph-small-regular option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading3').shortcuts) }}
                </span>
            </CompassDropdownOption>
            <CompassDropdownOption
                class="custom-menu-item"
                @itemSelected="getExtensionOption('Heading4').action()"
            >
                <h4 class="typographies-heading-h4 heading">
                    {{ $t.__(getExtensionOption('Heading4').label) }}
                </h4>
                <span class="typographies-paragraph-small-regular option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading4').shortcuts) }}
                </span>
            </CompassDropdownOption>
            <CompassDropdownOption
                class="custom-menu-item"
                @itemSelected="getExtensionOption('Heading5').action()"
            >
                <h5 class="typographies-heading-h5 heading">
                    {{ $t.__(getExtensionOption('Heading5').label) }}
                </h5>
                <span class="typographies-paragraph-small-regular option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading5').shortcuts) }}
                </span>
            </CompassDropdownOption>
            <CompassDropdownOption
                class="custom-menu-item"
                @itemSelected="getExtensionOption('Heading6').action()"
            >
                <h6 class="typographies-heading-h6 heading">
                    {{ $t.__(getExtensionOption('Heading6').label) }}
                </h6>
                <span class="typographies-paragraph-small-regular option-shortcuts-menu">
                    {{ $t.__(getExtensionOption('Heading6').shortcuts) }}
                </span>
            </CompassDropdownOption>
        </template>
    </CompassMenu>
</template>

<script>
import OptionsRichTextMixin from 'mixins/OptionsRichTextMixin';
import SelectRichText from 'vcomponents/richtext/customoptions/SelectRichText.vue';

export default {
    name: 'HeadingRichText',
    components: {
        SelectRichText,
    },
    mixins: [OptionsRichTextMixin],
    methods: {
        getExtensionOptionLabel() {
            return this.$t.__(this.getExtensionOption(this.option).label);
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-menu-item__richtext-code code {
    font-family: monospace;
    font-weight: 400;
    font-size: var(--font-size-12);
    line-height: var(--line-heights-16);
    color: var(--colors-common-text-standard-default);
}
</style>
